module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Título")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.news.title),
      expression: "news.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "title",
      "placeholder": "Entre com o título"
    },
    domProps: {
      "value": (_vm.news.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.news, "title", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.title) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.errors.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "date"
    }
  }, [_vm._v("Data")]), _vm._v(" "), _c('DatePicker', {
    attrs: {
      "placeholder": "Selecione a data",
      "bootstrapStyling": true,
      "language": _vm.datepickerLanguage
    },
    model: {
      value: (_vm.news.dateTime),
      callback: function($$v) {
        _vm.$set(_vm.news, "dateTime", $$v)
      },
      expression: "news.dateTime"
    }
  }), _vm._v(" "), (_vm.errors.dateTime) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.errors.dateTime))]) : _vm._e()], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body pad"
  }, [_c('vue-html5-editor', {
    attrs: {
      "content": _vm.news.content,
      "height": 300
    },
    on: {
      "change": _vm.updateContent
    }
  }), _vm._v(" "), (_vm.errors.content) ? _c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.errors.content))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary pull-right",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v("  Salvar\n      ")]), _vm._v(" "), _c('go-back-button')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Conteúdo")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a3e1d31","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/news/NewsForm.vue
// module id = 735
// module chunks = 1